/* Disabling the following linting - due to this bug https://github.com/evcohen/eslint-plugin-jsx-a11y/issues/477 */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';

import './filter-select.scss';

const FilterSelect = (props) => {

	const filterChange = (evt) => {
		const { filterUpdate } = props;

		filterUpdate({
			type: evt.currentTarget.dataset.target,
			value: evt.currentTarget.value,
		});
	};

	const renderOption = (filterOption) => {
		return (
			<option key={filterOption.id} value={filterOption.value}>{filterOption.name}</option>
		);
	};

	const {
		filterType,
		filterName,
		filterLabel,
		filterDefault,
		filterOptions,
	} = props;

	return (
		<div className="filter-select">
			<div className="select-group">
				<label className="select-label" htmlFor={filterName}>{filterLabel}</label>
				<div className="select-wrapper">
					<select className="select" data-target={filterType} name={filterName} id={filterName} onChange={filterChange}>
						<option value="">{filterDefault}</option>
						{filterOptions.map(renderOption)}
					</select>
				</div>
			</div>
		</div>
	);
};

FilterSelect.defaultProps = {
	filterDefault: 'All',
	filterUpdate: () => {},
};

FilterSelect.propTypes = {
	filterType: PropTypes.string.isRequired,
	filterName: PropTypes.string.isRequired,
	filterLabel: PropTypes.string.isRequired,
	filterDefault: PropTypes.string,
	filterOptions: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.string.isRequired,
		value: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	})).isRequired,
	filterUpdate: PropTypes.func,
};

export default FilterSelect;
